import { Element, Component, Host, h, State } from '@stencil/core';

@Component({
  tag: 'spw-mosaic-item',
  styleUrl: 'spw-mosaic-item.scss',
  shadow: true,
})
export class SpwMosaicItem {
  @Element() el: HTMLSpwMosaicItemElement;

  @State() classString: string = 'spw-tw-px-3 spw-tw-mb-6';

  componentDidLoad() {
    this.el.closest('spw-mosaic').addEventListener('mosaicConfigurationChanged', this.handleConfigurationChange.bind(this));
  }

  disconnectedCallback() {
    this.el.closest('spw-mosaic').removeEventListener('mosaicConfigurationChanged', this.handleConfigurationChange.bind(this));
  }

  private handleConfigurationChange(event) {
    const { colsMobile, colsTablet, colsDesktop } = event.detail;
    this.el.style.setProperty('--spw-mosaic-item-width-mobile', `calc(100% / ${colsMobile})`);
    this.el.style.setProperty('--spw-mosaic-item-width-tablet', `calc(100% / ${colsTablet})`);
    this.el.style.setProperty('--spw-mosaic-item-width-desktop', `calc(100% / ${colsDesktop})`);
  }

  render() {
    return (
      <Host>
        <slot></slot>
      </Host>
    );
  }
}
